import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import styles from './ContentSelector.module.scss';
import { getCatalogByCollectionIdAPI } from 'api/contentUploadAPI';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types'

export default function ContentSelector ({ setSelectContent, selectedCollections, setSelectedCollections, numberOfItems, selectContent, selectedCollectionsperRow, setSelectedCollectionsperRow, templateId }) {
    const collectionsdata = useSelector((state) => state.collections.collections);
    const [thumbnails, setThumbnails] = useState({});
    const [loading, setLoading] = useState(true);
    const [selectedRow, setSelectedRow] = useState(0);
    useEffect(() => {
        if (collectionsdata?.length > 0) {
            fetchThumbnails();
        }
    }, [collectionsdata]);

    const fetchThumbnails = async () => {
        const newThumbnails = { ...thumbnails };
        setLoading(true);

        await Promise.all(
            collectionsdata.map(async (collection) => {
                if (!newThumbnails[collection.id]) {
                    const firstItemThumbnail = await getFirstItemThumbnail(collection.id);
                    if (firstItemThumbnail) {
                        newThumbnails[collection.id] = firstItemThumbnail;
                    }
                }
            })
        );

        setThumbnails(newThumbnails);
        setLoading(false);
    };

    const getFirstItemThumbnail = async (id) => {
        try {
            const response = await getCatalogByCollectionIdAPI(id);
            const catalogsData = response?.data?.data?.result || null;
            if (catalogsData && catalogsData.length > 0) {
                return catalogsData[0]?.assest_urls?.[0]?.thumbnail || null;
            }
        } catch {
            return null;
        }
    };

    const handleSelectCollection = (id) => {
        let updatedSelection = [...selectedCollections];

        if (updatedSelection.includes(id)) {
            updatedSelection = updatedSelection.filter((item) => item !== id);
        } else {
            if (updatedSelection.length >= numberOfItems) {
                updatedSelection.shift();
            }
            updatedSelection.push(id);
        }

        setSelectedCollections(updatedSelection);
    };
    const handleSelectCollectionRow = (id) => {
        let updatedSelection = [...selectedCollectionsperRow];

        if (updatedSelection.includes(id)) {
            updatedSelection = updatedSelection.filter((item) => item !== id);
        } else {
            if (updatedSelection.length >= numberOfItems) {
                updatedSelection.shift();
            }
            updatedSelection.push(id);
        }

        setSelectedCollectionsperRow(updatedSelection);
    };

    const getOrderNumber = (id) => {
        return selectedRow === 0
            ? selectedCollections.indexOf(id) + 1 
            : selectedCollectionsperRow.indexOf(id) + 1;
    };

    if (loading) return <div>Loading...</div>
    return (
        createPortal(
            <div
                style={{ display: selectContent ? 'flex' : 'none' }}
                className={styles.selector}>
                <div className={styles.frame}>
                    <div className={styles.collections}>
                        {collectionsdata?.map((item) => (
                            <div
                                key={item.id}
                                className={`${styles.item} ${
                                    selectedRow === 0
                                        ? selectedCollections.includes(item.id)
                                            ? styles.selected
                                            : ''
                                        : selectedCollectionsperRow.includes(item.id)
                                            ? styles.selected
                                            : ''
                                    }`}
                                onClick={() => 
                                    selectedRow === 0 ? handleSelectCollection(item.id) : handleSelectCollectionRow(item.id)
                                }
                            >
                                {thumbnails[item.id]
                                    ? (
                                        <img src={`https://cdn.publisher.masterwizr.com/${thumbnails[item.id]}`} alt={`Thumbnail for ${item.name}`} />
                                    )
                                    : (
                                        <div className={styles.dotLoader} />
                                    )}
                                <p>{item?.name}</p>
                                {(selectedCollections.includes(item.id) || selectedCollectionsperRow.includes(item.id)) && getOrderNumber(item.id) > 0 
                                ? (<span className={styles.orderNumber}>{getOrderNumber(item.id)}</span>) 
                                : null}

                            </div>
                        ))}
                    </div>
                    <div className={styles.buttons}>
                        <button onClick={() => setSelectContent(false)}>Cancel</button>
                        <button
                            onClick={() => setSelectContent(false)}
                            disabled={selectedCollections.length !== numberOfItems}>Save</button>
                    </div>
                    {(templateId === 6 || templateId === 7) &&
                        <div className={styles.rows}>
                                <div className={styles.buttonsrows}>
                                    <button
                                    className={`${styles.row} ${selectedRow === 0 ? styles.selected : ''}`}
                                     onClick={() => setSelectedRow(0) }>Row 1</button>
                                    <button 
                                    className={`${styles.row} ${selectedRow === 1 ? styles.selected : ''}`}
                                    onClick={() => setSelectedRow(1)}>Row 2</button>
                                </div>
                        </div>
                    }
                </div>
            </div>,
            document.getElementById('modal-root')
        )
    );
}

ContentSelector.propTypes = {
    setSelectContent: PropTypes.func,
    selectedCollections: PropTypes.array,
    setSelectedCollections: PropTypes.func,
    numberOfItems: PropTypes.number,
    selectContent: PropTypes.bool,
    selectedCollectionsperRow: PropTypes.array,
    setSelectedCollectionsperRow: PropTypes.func,
    templateId: PropTypes.number
}
